import React from 'react';
import { Link } from 'react-router-dom';
import AreaView from './components/areaView';
import Reception from './components/reception';
import Queue from './components/queue';
import BaseContainer from '../../containers/base';
import { Redirect } from 'react-router-dom'
import { Button, Menu, Dropdown, Icon, message } from 'antd';
import Common from '../../components/common'
import { Motion, spring, presets } from 'react-motion'
import './index.scss'
import MqttClient from '../../utils/websocket';
// const mqttClient = new MqttClient();
export default class Home extends BaseContainer {
    constructor(props) {
        super(props);
        this.state = {
            curTabName: 'index',
            leftViewType: false,
            StaffInfo: Common.getUserInfo(),
            isLoginSuccess: sessionStorage.getItem('token') ? true : false,
            left: 1,//动画用初始位置
        }
    }
    componentDidMount() {
        if(this.state.isLoginSuccess){
            // websocket.init();
            MqttClient.connect();
        }
        this.clickHandler()
    }

    /**
     * 退出登录
     */
    goOut = (param) => {
        if (param.key == 2) {
            sessionStorage.clear();
            const isLoginSuccess = sessionStorage.getItem('token') ? true : false
            this.setState({
                isLoginSuccess
            });
            // websocket.disConnect();
            MqttClient.disConnect();
        }
        if (param.key != 2) {
            message.warning('敬请期待！')
        }
    }
    /**
     * 动画
     */
    clickHandler = () => {
        let targetX = 0
        if (this.state.left === 0) {
            targetX = 230
        } else {
            targetX = 0
        }

        this.setState({
            left: targetX
        })
    }

    render() {
        const { curTabName, left, StaffInfo, isLoginSuccess } = this.state;
        const offSW = document.querySelector('body').offsetWidth - 120;
        return (
            isLoginSuccess ? <div style={{ backgroundColor: '#1C1736', width: '100%', display: 'flex', flexDirection: 'row' }}>
                <Motion style={{ x: spring(this.state.left, presets.wobbly) }}>
                    {interpolatingStyle => {
                        // debugger
                        return (
                            <div style={{ width: `translateX(${interpolatingStyle.x}px)` }} >

                                {/* 左侧Tab */}
                                <div style={{ width: left ? 230 : 80, height: '100%', background: '#242140', transition: 'width 1s', position: 'fixed', top: 0, left: 0, display: 'flex', alignItems: 'center', paddingTop: 60, flexDirection: 'column', zIndex: 99999 }} onMouseOver={() => {
                                    this.clickHandler()
                                }} onMouseOut={() => {
                                    this.clickHandler()
                                }} >
                                    <div style={{ display: 'flex', backgroundColor: left ? '' : '#000', width: 53, height: 53, justifyContent: 'center', alignItems: 'center', borderRadius: '50%', transition: ' all ease 1s', position: 'relative', }}>
                                        <img src={require('../../images/logo_1.png')} style={{ width: left ? 60 : 24, height: left ? 35 : 14, transition: ' all ease 1s', position: 'absolute', top: left ? 5 : 12, left: left ? -60 : 15 }}></img>
                                        <img src={require('../../images/logo_2.png')} style={{ width: left ? 120 : 45, height: left ? 35 : 14, transition: ' all ease 1s', position: 'absolute', top: left ? 5 : 25, left: left ? 0 : 5 }}></img>
                                    </div>
                                    <div style={{ position: 'fixed', top: 122, left: left ? 31 : -80, transition: ' all linear 0.8s', }}>
                                        <span style={{ fontSize: 18, color: 'white', opacity: left ? 1 : 0, visibility: left ? 'visible' : 'hidden', transition: ' all linear 0.4s', marginLeft: 28 }}>场控管理后台</span>
                                    </div>
                                    <Button style={{ width: left ? 203 : 53, height: 53, backgroundColor: curTabName == 'index' ? '#1A1736' : '#242140', borderRadius: 27.5, marginTop: 116, transition: 'width 1s', alignItems: 'center', display: 'flex', border: 'none' }} onClick={() => { this.setState({ curTabName: 'index' }) }}>
                                        <img src={require('../../images/home_icon.png')} style={{ width: 24, height: 24, }} />
                                        <span style={{ fontSize: 14, color: 'white', opacity: left ? 1 : 0, visibility: left ? 'visible' : 'hidden', transition: ' all linear 0.4s', marginLeft: 28 }}>首页</span>
                                    </Button>
                                    <Button style={{ width: left ? 203 : 53, height: 53, backgroundColor: curTabName == 'area' ? '#1A1736' : '#242140', borderRadius: 27.5, marginTop: 10, transition: 'width 1s', alignItems: 'center', display: 'flex', border: 'none' }} onClick={() => { this.setState({ curTabName: 'area' }) }}>
                                        <img src={require('../../images/manger_icon.png')} style={{ width: 24, height: 24, }} />
                                        <span style={{ fontSize: 14, color: 'white', opacity: left ? 1 : 0, visibility: left ? 'visible' : 'hidden', transition: ' all linear 0.4s', marginLeft: 28 }}>区域管理</span>
                                    </Button>
                                    <Button style={{ width: left ? 203 : 53, height: 53, backgroundColor: curTabName == 'views' ? '#1A1736' : '#242140', borderRadius: 27.5, marginTop: 10, transition: 'width 1s', alignItems: 'center', display: 'flex', border: 'none' }} onClick={() => { this.setState({ curTabName: 'views' }) }}>
                                        <img src={require('../../images/shitu_icon.png')} style={{ width: 24, height: 24, }} />
                                        <span style={{ fontSize: 14, color: 'white', opacity: left ? 1 : 0, visibility: left ? 'visible' : 'hidden', transition: ' all linear 0.4s', marginLeft: 28 }}>区域视图</span>
                                    </Button>
                                    {/* 
                                    
                                    
                                     */}
                                </div>
                            </div>
                        )
                    }}
                </Motion>
                {/* <Button onClick={()=>{this.clickHandler()}} onMouseOver={()=>{this.clickHandler()}} onMouseOut={()=>{
                        this.clickHandler()
                    }}>run</Button> */}

                {/* 右侧 */}
                <div style={{ marginLeft: 80 }}>
                    <div style={{ display: 'flex', width: offSW, height: 80, background: '#1A1736', alignItems: 'center', justifyContent: 'space-between', paddingLeft: 30, paddingRight: 30, position: 'fixed', top: 0, left: 100, zIndex: 999 }}>
                        <span style={{ color: 'white', fontSize: 14 }}>{curTabName == 'index' ? '首页' : curTabName == 'area' ? '区域管理' : '区域视图'}</span>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', width: 174, height: 54, }}>
                            <img src={require('../../images/userHeader_icon.png')} style={{ width: 36, height: 36 }} />
                            <Dropdown overlay={<MenuList onPress={(param) => { this.goOut(param) }} />}>
                                <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 10, alignItems: 'center' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span style={{ color: 'white' }}>{StaffInfo.staffName}</span>
                                        <span style={{ color: '#E25050' }}>{StaffInfo.roleName}</span>
                                    </div>
                                    <Icon type="caret-down" style={{ marginLeft: 8 }} />
                                </div>
                            </Dropdown>
                        </div>
                    </div>
                    <div style={{ background: '#1A1736', display: 'flex', padding: 20, marginTop: 80 }}>
                        {
                            curTabName == 'index' ? <Reception /> : curTabName == 'area' ? <Queue /> : <AreaView />
                        }
                    </div>
                </div>
            </div> : <Redirect
                    to={{
                        pathname: "/login",
                    }}
                />
        );
    }
}

class MenuList extends React.Component {
    static defaultProps = {
        item: null
    }

    render() {
        const styles = { fontSize: 14 }
        const stylea = { color: '#646884', width: 22, height: 22 }
        return (
            <Menu onClick={(param) => { this.props.onPress(param) }} style={{ marginTop: 20, backgroundColor: '#242140', border: 'none', color: 'white', padding: '10px 0', borderRadius: 8, boxShadow: '8px 8px 8px 8px rgba(21,19,46,0.56)' }}>
                <Menu.Item key="0" style={styles}><Icon type="calendar" style={stylea} />入门教程 <Icon type="caret-right" style={{ marginLeft: 30 }} /></Menu.Item>
                <Menu.Item key="1" style={styles}><Icon type="question-circle-o" style={stylea} />帮助<Icon type="caret-right" style={{ marginLeft: 62 }} /></Menu.Item>
                <Menu.Item key="2" style={styles}><Icon type="logout" style={stylea} />退出登录</Menu.Item>
            </Menu>
        );
    }
}